/** 叫貨批次狀態標籤(總覽表與批次頁共用) */
import type { SupplyBatchStatus } from "../api/admin";

const STYLE: Record<SupplyBatchStatus, string> = {
  planned: "bg-line/40 text-charcoal/70",
  draft: "bg-sage-light text-charcoal",
  ordered: "bg-sage text-white",
  arrived: "bg-primary-dark text-white",
  shipping: "bg-coral text-white",
  shipped: "bg-primary text-white",
};

export default function SupplyStatusPill({
  status,
  label,
}: {
  status: SupplyBatchStatus;
  label: string;
}) {
  return (
    <span className={`inline-block whitespace-nowrap text-xs px-2.5 py-0.5 rounded-full ${STYLE[status] || "bg-line text-muted"}`}>
      {label}
    </span>
  );
}
